import React, {useEffect, useState} from "react";
import ProgressBarCanvas from "./ProgressBarCanvas";
import '../../../styles/components/lesson/progress-bar.scss';
import {
  seekSkipBack,
  seekSkipForward,
  subscribeToNotesDurationAndSeekOffsetChangedEvents
} from "../../../services/eventBus/notes/notesEventBus";
import {IDurationAndSeekOffsetSecondsChanged} from "../../../services/eventBus/notes/NotesEventTypes";
import {FontIcon} from "../../common/FontIcon";
import soundSlice from "../../../services/soundSlice/soundSlice";
import {formatSeconds, formatSecondsToMinutesAndSeconds} from "../../../util/number-util";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export function ProgressBar() {
  const isProgressBarShown = useAppSelector(lessonPlayerStore.getIsProgressBarShown);
  const [durationMinutesAndSeconds, setDurationMinutesAndSeconds] = useState("");
  const [seekMinutesAndSeconds, setSeekMinutesAndSeconds] = useState("");

  useEffect(()=>subscribeToNotesDurationAndSeekOffsetChangedEvents((m: IDurationAndSeekOffsetSecondsChanged)=> {
    const formatted = formatDurationAndSeekTimes(m.duration, m.seekOffset);
    setDurationMinutesAndSeconds(formatted.durationMinutesAndSeconds);
  }), []);

  //fix issue where playbackOrchestrator isn't so great at knowing the current seek time for videos.  Poll SS every second to get the time.
  useEffect(()=> {
    const intervalId = setInterval(async ()=> {
      const currentTime = await soundSlice.getCurrentTime();
      const seekMinutesAndSeconds = formatSecondsToMinutesAndSeconds(currentTime);
      setSeekMinutesAndSeconds(seekMinutesAndSeconds);
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const hideClassName = isProgressBarShown ? "" : "hide-progress-bar";

  return (
    <div className={`progress-bar ${hideClassName}`}>
      <button title={"Back 5 seconds"} aria-label={"Back 5 seconds"} className="rewind-button" onClick={() => seekSkipBack()}><FontIcon icon={`icon-jump-backward`}/><span>5</span></button>
      <div className="seek-offset" title={"Time elapsed"}>{seekMinutesAndSeconds}</div>
      <ProgressBarCanvas/>
      <div className="duration-seconds" title={"Total time"}>{durationMinutesAndSeconds}</div>
      <button title={"Forward 5 seconds"} aria-label={"Forward 5 seconds"} className="fast-forward-button" onClick={()=> seekSkipForward()}><FontIcon icon={`icon-jump-forward`}/><span>5</span></button>
    </div>
  );
}

function formatDurationAndSeekTimes(durationSeconds: number, seekOffset: number){
  const minutes = Math.floor(durationSeconds / 60) || 0;
  const seconds = formatSeconds(Math.floor(durationSeconds % 60) || 0);
  const durationMinutesAndSeconds = `${ minutes}:${ seconds}`;

  const seekMinutes = Math.floor(seekOffset / 60) || 0;
  const seekSeconds = formatSeconds(Math.floor(seekOffset % 60)|| 0);
  const seekMinutesAndSeconds = `${seekMinutes}:${seekSeconds}`;
  return {durationMinutesAndSeconds, seekMinutesAndSeconds};
}
